// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plain-text-composer {
  box-sizing: border-box;
  min-height: 2.5rem;
  max-height: min(10rem, 30vh);
  max-height: min(10rem, 30dvh);
  overflow-x: hidden;
  overflow-y: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.plain-text-composer[data-placeholder]:empty::before {
  content: attr(data-placeholder);
  color: inherit;
  pointer-events: none;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/PlainTextComposer.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":[".plain-text-composer {\n  box-sizing: border-box;\n  min-height: 2.5rem;\n  max-height: min(10rem, 30vh);\n  max-height: min(10rem, 30dvh);\n  overflow-x: hidden;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.plain-text-composer[data-placeholder]:empty::before {\n  content: attr(data-placeholder);\n  color: inherit;\n  pointer-events: none;\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
